import React, {useState, useEffect, useRef} from 'react';
import {Button, Layout, Menu, Dropdown, Modal, Space, Avatar} from 'antd';
import {DownOutlined, UserOutlined } from '@ant-design/icons';
import styles from './layout.module.less';
import logo from './logo.png';

import BackTop from 'components/BackTop/BackTop'
import Breadcrumb from 'components/Breadcrumb'
import {history,setReferrerUrl} from "libs";
// the hook
import {useTranslation} from 'react-i18next';


export default function (props) {
  const {t, i18n} = useTranslation();// {t('')}

  const {visible, setVisible} = useState(false)

  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevPath = usePrevious(history.location.pathname)

  useEffect(() => {
    setReferrerUrl(prevPath)
  }, [history.location.pathname])

  const logout = () => {
    Modal.confirm({
      title: t('温馨提示'),
      content: t('确定要注销退出吗？'),
      okText: t('确认'),
      cancelText: t('取消'),
      onOk: () => {
        localStorage.setItem('token', '');
        localStorage.setItem('nickname', '');
        localStorage.setItem('redirect_uri', history.location.pathname + history.location.search + history.location.hash);
        history.push('/login')
      }
    });
  }

  const activeClass = (path)=>{
    if(history.location.pathname.indexOf(path)!==-1){
      return 'active_nav'
    }
  }

  let token = localStorage.getItem('token');
  let nickName = localStorage.getItem('nickname');
  const userMenu = (
    <Menu>
      {/* <Menu.Item>
        <a onClick={() => {
          history.push('/cart')
        }}>{t('我的购物车')}</a>
      </Menu.Item> */}
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/purchase')
        }}>{t('求购记录')}</a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/order')
        }}>{t('交易记录')}</a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/project')
        }}>{t('我的管理')}</a>
      </Menu.Item>
      {/* <Menu.Item>
        <a onClick={() => {
          history.push('/user/info')
        }}>{t('系统设置')}</a>
      </Menu.Item> */}
      <Menu.Divider/>
      <Menu.Item>
        <a onClick={logout}>{t('注销退出')}</a>
      </Menu.Item>
    </Menu>
  )

  const changeLang=(lang)=>{
    i18n.changeLanguage(i18n.language === 'en' ? 'zh' : 'en').then(()=>{
      localStorage.setItem('Language', i18n.language);
    })
  }

  return (
    <React.Fragment>
      <div className={styles.headerContainer}>
        <Layout.Header className={styles.header}>
          <div className={styles.left}>
            <a href="" className={styles.logo} title={t('首页')}>
              <img src={logo} alt="Logo"/>
            </a>
          </div>
          <div className={styles.right}>
            <ul className={styles.navs}>
              <li className={[styles.nav,activeClass('/home')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/home')}>{t('首页')}</a></li>
              <li className={[styles.nav,activeClass('/business')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/business')}>{t('服务介绍')}</a></li>
              <li className={[styles.nav,activeClass('/goods')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/goods')}>{t('产品展示')}</a>
              </li>
              <li className={[styles.nav,activeClass('/fqa')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/fqa')}>{t('常见问题')}</a></li>
              <li hidden={!token} className={[styles.nav,activeClass('/cart')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/cart')}>{t('我的购物车')}</a></li>

              <li hidden={!token} className={styles.nav}>
                <Dropdown overlay={userMenu} placement="bottomCenter" arrow>
                  <a className={['ant-dropdown-link', styles.link].join(" ")} onClick={() => {
                    history.push('/user/purchase')
                  }}><Avatar style={{
                    backgroundColor: '#65B1AE',
                  }} icon={<UserOutlined />} /> {nickName} <DownOutlined/></a>
                </Dropdown>
              </li>

              <li hidden={!!token} className={styles.nav}>
                <span className={[styles.link,'active_link'].join(' ')} onClick={() => {
                  history.push('/register')
                }}>{t('注册')}</span>
                <span style={{verticalAlign: 1}}>/</span>
                <span className={[styles.link,'active_link'].join(' ')} onClick={() => {
                  history.push('/login')
                }}>{t('登录')}</span>
              </li>
              {/* <li className={styles.nav}>
                <a onClick={changeLang}>{i18n.language === 'en' ? '中文' : 'English'}</a>
              </li> */}
            </ul>
          </div>
        </Layout.Header>
      </div>

      <Breadcrumb showBrand={props.showBrand} crumb={props.crumb}/>

      <div hidden={props.hideToTop}>
        <BackTop/>
      </div>

    </React.Fragment>
  )
}

